module.exports = __webpack_public_path__ + "img/1568339983.2b348cd8.jpg";